// import animateLinesInit from "../components/_animate-lines";
import gsapDataTrigger from "../components/_gsap-data-trigger";
import responsiveVideo from "../components/_responsive-video";

gsapDataTrigger();
responsiveVideo();

/* ============ SET VIDEO RATIO RESPONSIVELY ============ */
const vidRatioWrapper = document.querySelector("#vid-ratio-wrapper");

document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth >= "1200") {
        vidRatioWrapper.classList.add("ratio", "ratio-16x9");
    }

    // If url contains hash "#give" then fire giving form modal (from /give/index.kit)
    window.location.hash === "#give" && document.querySelector(".nav-gift-btn").click();
});

window.addEventListener("resize", () => {
    if (window.innerWidth < "1200") {
        vidRatioWrapper.classList.remove("ratio", "ratio-16x9");
    } else {
        vidRatioWrapper.classList.add("ratio", "ratio-16x9");
    }
});
